module.exports = __webpack_public_path__ + "img/ROW_SEPARATOR.4afa477e.svg";